import {BaseAppModel} from "./AppModel";

export default class Category extends BaseAppModel<Category> {
    key!: string
    name!: string
    isCustom!: boolean
}

export enum CategoryType {
    STANDARD = "STANDARD",
    CUSTOM = "CUSTOM",
}
